import { config } from "../../config";

import { SubledgerEndpoints } from "../../SubledgerEndpoints";
import { authGet } from "../../services/RequestHelpers";
import { ISLEntryGridItem } from "../../schemas/SLEntryGridSchemas";
import { IUserProviderState } from "../../contexts/UserContext";

export async function getDashboard(
  dashboardStatusFilter: string,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ISLEntryGridItem[]> {
  const getSlDashboardUrl = config.get("subledgerUrl") + SubledgerEndpoints.slDashboard + dashboardStatusFilter;
  const result = await authGet(getSlDashboardUrl, getTokenFn);
  let gridItems: ISLEntryGridItem[] = [];
  if (result !== undefined) {
    if (result.status === 404 || result.data === null) {
      alert("There are no SL entries to show. Please go to /slcreate to create a new SL entry.");
    } else {
      gridItems = result.data;
      gridItems.forEach((entry) => {
        if (entry.attachmentCount !== undefined) {
          if (entry.attachmentCount > 1) {
            entry.attachmentFileName = entry.nameDocumentId;
          }
        }
      });
    }
  }
  return gridItems;
}
